import { useEffect } from 'react';

window.MATHJAX_TYPESET = window.MATHJAX_TYPESET || {};

// there is an issue in LRN which causes MathJax clear cache and typeset the whole DOM on every call to app.addItems
// we fixing it by replacing original MathJax methods and calling typeset only on the DOM element we need
// https://help.learnosity.com/hc/en-us/requests/23047

export default function () {
  useEffect(() => {
    const isAlreadyReplaced =
      window.MATHJAX_TYPESET.typeset && window.MATHJAX_TYPESET.typesetClear;

    if (window.MathJax) {
      if (!isAlreadyReplaced) {
        window.MATHJAX_TYPESET.typeset = window.MathJax.typeset;
        window.MATHJAX_TYPESET.typesetClear = window.MathJax.typesetClear;
      }
      window.MathJax.typeset = () => {};
      window.MathJax.typesetClear = () => {};
    }

    return () => {
      restoreMathJax();
    };
  }, [window.MathJax]);
}

export function useRestoreMathJax() {
  useEffect(() => {
    restoreMathJax();
  }, []);
}

export function restoreMathJax() {
  if (
    window.MathJax &&
    window.MATHJAX_TYPESET.typeset &&
    window.MATHJAX_TYPESET.typesetClear
  ) {
    window.MathJax.typeset = window.MATHJAX_TYPESET.typeset;
    window.MathJax.typesetClear = window.MATHJAX_TYPESET.typesetClear;
  }
}
